let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("as9qs")).then(() => parcelRequire('5zvIl'));